/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { getEntityIcon } from 'utils/helpers';
import { FORM, IMPORT_DIALOG_SOURCE } from 'utils/constants';

import BaseImportService from './BaseImportService';
import { extractFileNameFromResourceUrl, prepareOutputForSingleTemplate } from './ImportHelpers';

class ImportFormService extends BaseImportService {
  async import({ selectedProject, resourcesMetadata }) {
    // @ts-expect-error TS2345
    return this.importNoDuplicateCheck({
      selectedProject,
      resourcesMetadata,
      source: IMPORT_DIALOG_SOURCE
    });
  }

  extractFileName(template, resource) {
    return extractFileNameFromResourceUrl(template, resource);
  }

  duplicatesNotAllowed() {
    return false;
  }

  async prepareOutput(template) {
    return prepareOutputForSingleTemplate(template, FORM);
  }

  extractIcon(_template, _resource) {
    return getEntityIcon({ type: FORM });
  }

  executePostImportAction(history, _selectedProject, importedFiles) {
    if (importedFiles?.length > 0) {
      history.push(`/forms/${importedFiles[0].id}`);
    }
  }
}

export default new ImportFormService();
